import { Form } from '@/components';
import { useProjectLookupSource } from '../Projects.Common';
import * as Yup from 'yup';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';

const schema = Yup.object({
  projectIds: Yup.array().of(Yup.string().required()).nullable().defined(),
});

type HomeBaselineFilterValues = Yup.InferType<typeof schema>;

const INITIAL_VALUES: HomeBaselineFilterValues = { projectIds: [] };

interface Props {
  projectIds: string[];
  onSubmit: (value: HomeBaselineFilterValues) => void;
  className?: string;
}

function ProjectsFormPanel(props: Props) {
  const { projectIds, className } = props;
  const projectDataSource = useProjectLookupSource({ ids: projectIds });
  const { values, submitForm } = useFormikContext<HomeBaselineFilterValues>();

  useEffect(() => {
    submitForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.projectIds]);

  return (
    <div className={className}>
      <Form.AsyncSelect
        dataSource={projectDataSource}
        name="projectIds"
        inline
      />
    </div>
  );
}

export function HomeBaselineFilterPanel(props: Props) {
  const { onSubmit } = props;

  return (
    <Form.Formik<HomeBaselineFilterValues>
      uid="home-baseline-filter"
      i18n="homes.baseline.filter"
      validationSchema={schema}
      onSubmit={onSubmit}
      initialValues={INITIAL_VALUES}
    >
      <ProjectsFormPanel {...props} />
    </Form.Formik>
  );
}
